/* Xenia stitching relationship controller — Shopify native nested cart lines */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let busy = false;

  async function cartJSON() {
    const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!r.ok) throw new Error('Unable to read cart.');
    return r.json();
  }

  async function update(updates) {
    const r = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!r.ok) throw new Error('Unable to update cart.');
    return r.json();
  }

  function parentKeyFor(item) {
    return item?.parent_relationship?.parent_key || item?.key || '';
  }

  function familyUpdates(cart, clickedKey, quantity) {
    const clicked = cart.items.find(item => item.key === clickedKey);
    if (!clicked) return {};
    const parentKey = parentKeyFor(clicked);
    const updates = {};
    cart.items.forEach(item => {
      if (item.key === parentKey || item.parent_relationship?.parent_key === parentKey) {
        updates[item.key] = quantity;
      }
    });
    return updates;
  }

  async function updateFamily(clickedKey, quantity) {
    const cart = await cartJSON();
    const updates = familyUpdates(cart, clickedKey, quantity);
    if (!Object.keys(updates).length) return false;
    await update(updates);
    return true;
  }

  // Removing either the outfit or one of its stitching children removes the full outfit.
  document.addEventListener('click', async event => {
    const remove = event.target.closest('[data-remove-item]');
    if (!remove || busy) return;
    const line = remove.closest('[data-input-item]');
    const key = line?.dataset.key;
    if (!key) return;

    // Only take over removal for a nested child or a parent that actually has nested children.
    const cart = await cartJSON().catch(() => null);
    if (!cart) return;
    const clicked = cart.items.find(item => item.key === key);
    if (!clicked) return;
    const parentKey = parentKeyFor(clicked);
    const isNestedFamily = !!clicked.parent_relationship || cart.items.some(item => item.parent_relationship?.parent_key === parentKey);
    if (!isNestedFamily) return;

    event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
    busy = true;
    try {
      const updates = familyUpdates(cart, key, 0);
      await update(updates);
      window.location.reload();
    } catch (e) {
      console.error('Xenia nested stitching remove error:', e);
      busy = false;
    }
  }, true);

  // Keep parent and stitching child quantities synchronized.
  document.addEventListener('click', event => {
    if (event.target.closest('[data-remove-item]')) return;
    const button = event.target.closest('button');
    const line = event.target.closest('[data-input-item]');
    if (!button || !line?.dataset.key) return;
    const qty = line.querySelector('input[type="number"], input[name="updates[]"]');
    if (!qty) return;

    setTimeout(async () => {
      try {
        const cart = await cartJSON();
        const clicked = cart.items.find(item => item.key === line.dataset.key);
        if (!clicked) return;
        const parentKey = parentKeyFor(clicked);
        const isNestedFamily = !!clicked.parent_relationship || cart.items.some(item => item.parent_relationship?.parent_key === parentKey);
        if (!isNestedFamily) return;
        const n = Math.max(0, parseInt(qty.value || '0', 10));
        await update(familyUpdates(cart, line.dataset.key, n));
        window.location.reload();
      } catch (e) {
        console.error('Xenia nested stitching quantity error:', e);
      }
    }, 80);
  }, true);
})();
